export default __webpack_public_path__ + "static/media/footer-bg.675e6c49.png";